const crudState = {
  INDEX: 1,
  CREATE: 2,
  DELETE: 3,
  EDIT: 4,
  SHOW: 5,
}

export default crudState
